module.exports = __webpack_public_path__ + "media/img/bg-map-9db1a7c0.png";